import { render } from "./ServerError.vue?vue&type=template&id=29a22174"
import script from "./ServerError.vue?vue&type=script&lang=js"
export * from "./ServerError.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__